<template>
    <div class="d-flex d-md-none align-center mobile-facet-filters mb-2 pa-4">
        <p class="mb-0 text--secondary font-italic">
            <span v-if="filteredProfiles.length > 1">{{ filteredProfiles.length }} profielen gevonden</span>
            <span v-else-if="filteredProfiles.length <= 0">Geen profielen gevonden</span>
            <span v-else>Eén profiel gevonden</span>
        </p>
        <v-dialog
            v-model="dialog"
            width="500"
            scrollable
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="primary"
                    dark
                    rounded
                    v-bind="attrs"
                    v-on="on"
                    class="ml-auto"
                    elevation="0"
                >
                    <v-icon
                        left
                    >fa fa-filter</v-icon>

                    Filters
                </v-btn>
            </template>

            <v-card>
                <v-card-title class="pa-0">
                    <v-toolbar flat class="text-h5 grey lighten-2">
                        <v-toolbar-title>Filters</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            dark
                            rounded
                            elevation="0"
                            @click="dialog = false"
                        >
                            Toepassen
                        </v-btn>
                    </v-toolbar>
                </v-card-title>

                <v-card-text>
                    <FilterList class="mt-3"></FilterList>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        @click="dialog = false"
                    >
                        Sluiten
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import FilterList from "./FilterList";
import {mapState} from "vuex";

export default {
    name: "FilterPopup",
    components: {FilterList},
    data: () => ({
        dialog: false,
    }),
    computed: {
        ...mapState({
            filteredProfiles: state => state.profile.filteredProfiles
        })
    }
}
</script>

<style scoped>

</style>
